export class ApiError extends Error {
  constructor(
    public readonly statusCode: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class ValidationError extends ApiError {
  constructor(field: string, message: string) {
    super(400, 'VALIDATION_ERROR', `${field}: ${message}`);
  }
}

export class FetchError extends ApiError {
  constructor(resource: string, statusText: string) {
    super(500, 'FETCH_ERROR', `Failed to fetch ${resource}: ${statusText}`);
  }
}

export class SubmitError extends ApiError {
  constructor(resource: string, statusText: string) {
    super(500, 'SUBMIT_ERROR', `Failed to submit ${resource}: ${statusText}`);
  }
}

export class UpdateError extends ApiError {
  constructor(resource: string, statusText: string) {
    super(500, 'UPDATE_ERROR', `Failed to update ${resource}: ${statusText}`);
  }
}

export class NotFoundError extends ApiError {
  constructor(resource: string) {
    super(404, 'NOT_FOUND', `${resource} not found`);
  }
}

export class WithdrawError extends ApiError {
  constructor(resource: string, statusText: string) {
    super(500, 'WITHDRAW_ERROR', `Failed to withdraw ${resource}: ${statusText}`);
  }
}

export class CreateError extends ApiError {
  constructor(resource: string, statusText: string) {
    super(500, 'CREATE_ERROR', `Failed to create ${resource}: ${statusText}`);
  }
}
